export const endpoints = {
  applyCoupon: (oid) => `/oms/order/${oid}/discount-apply`,
  removeCoupon: (oid, uuid) => `/oms/order/${oid}/discount-remove/${uuid}`,
  applyTip: (oid) => `/oms/order/${oid}/tip-apply`,
  orderDetails: (oId) => `/back/order/details/${oId}`,
  billingPaymentIntent: () => `/billing/payment-intent/create`,
  billingPaymentIntentUpdate: () => `/billing/payment-intent/update`,
  applyPayment: (orderId) => `/billing/order/${orderId}/pay-cash`,
  applyPaymentCard: () => `/billing/payment/create`,
  getPaymentSystem: (businessId) =>
    `billing/payment-system/business/${businessId}`,
  getStripeAccount: (businessId) =>
    `billing/stripe-account/business/${businessId}`,
  createAdyenSession: () => `/billing/adyen/session`,
  completeAdyenSession: () => `/billing/adyen/session/complete`,
};
